angular.module('contabilidad.polizasexternas')
  .config(function ($stateProvider) {
    $stateProvider.state('contabilidad.polizasexternas', {
      url: '/polizasexternas',
      data: {title: 'Pólizas Externas'},
      resolve: {
        busqueda: function ($stateParams) {
          return $stateParams
        },
      },
      template: '<div style="margin:0 auto" max-width="lg"><ui-view><contabilidad-polizasexternas></contabilidad-polizasexternas></ui-view></div>',
      controller: function Controller ($scope, busqueda) {
        $scope.busqueda = busqueda
      },
    })
  })



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/routes/polizasexternas.js